import {useDispatch, useSelector, TypedUseSelectorHook} from "react-redux";
import {ThunkDispatch} from "redux-thunk";
import {AnyAction} from "redux";

import store from "./store";

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = ThunkDispatch<RootState, unknown, AnyAction>;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
